import { ReactNode, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import { getChatRole, getChatToken } from "../../utils/api"
import { WEBSOCKET_CONNECT_URL } from "../../utils/constants"

import { Spinner } from "components/Spinner"
import { useAuthContext } from "modules/PsychologistAccount/AuthContext"
import { SocketProvider } from "utils/contexts/SocketContext"
import { AppDispatch } from "utils/store/store"
import { chatSelector } from "utils/store/selectors/chat"
import { ROLES } from "utils/constants"

export function ChatSocketWrapper({ children }: { children: ReactNode }) {
    const dispatch = useDispatch<AppDispatch>()
    const [, { isSignedIn: isPsy }] = useAuthContext()
    const { role, token } = useSelector(chatSelector)

    useEffect(() => {
        void dispatch(getChatRole(isPsy ? ROLES.PSY : ROLES.CLIENT))
    }, [])

    useEffect(() => {
        if (role) {
            void dispatch(getChatToken(role))
        }
    }, [role])

    const onConnectSocketError = () => {
        if (role) {
            void dispatch(getChatToken(role, false))
        }
    }

    return token ? (
        <SocketProvider
            url={`${WEBSOCKET_CONNECT_URL}${token}`}
            onConnectError={onConnectSocketError}
        >
            {children}
        </SocketProvider>
    ) : (
        <Spinner />
    )
}
